import useDefinedContext from "hooks/useDefinedContext";
import { CarouselContext } from "../../Carousel";

/**
 * @important
 * This hook should only be used inside the Carousel component.
 */
function useCarousel() {
  return useDefinedContext(CarouselContext);
}

export default useCarousel;
